// Download helper for Consumer Voice reports (client-side react-pdf, like
// reportFiles.tsx). Lazy requires keep the headless PDF harness importable.
import React from 'react';
import toast from 'react-hot-toast';
import { pdf } from '@react-pdf/renderer';
import { ConsumerVoiceAudit, cvSubjectLabel } from '../../types/consumerVoice';
import { ConsumerVoicePdf } from './ConsumerVoicePdf';
import { downloadBlob } from '../PdpAudit/reportFiles';

const slug = (v: string) =>
  v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'product';

export async function buildConsumerVoicePdfBlob(audit: ConsumerVoiceAudit): Promise<Blob> {
  return pdf(React.createElement(ConsumerVoicePdf, { audit }) as any).toBlob();
}

export function consumerVoiceFileName(audit: ConsumerVoiceAudit): string {
  const when = audit.scored_at ? audit.scored_at.slice(0, 10) : 'draft';
  return `CV-Audit-${slug(cvSubjectLabel(audit))}-${when}.pdf`;
}

// Fetches the detail (the list payloads omit `report`) and saves the PDF.
export async function downloadConsumerVoicePdf(detailEndpoint: string): Promise<void> {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const axiosInstant = require('../../api').default;
  const toastId = toast.loading('Preparing PDF…');
  try {
    const res = await axiosInstant.get(detailEndpoint);
    const audit = res.data as ConsumerVoiceAudit;
    if (!audit || !audit.report) throw new Error('NoReport');
    const blob = await buildConsumerVoicePdfBlob(audit);
    downloadBlob(blob, consumerVoiceFileName(audit));
    toast.success('Report downloaded', { id: toastId });
  } catch {
    toast.error("Couldn't build the report file. Please try again.", { id: toastId });
  }
}
